import './Story.scss';
import React from 'react';

import { cn } from '../../utils/bem';
import { Typography } from '@dataartdev/uikit/Typography';
import { Group } from '../ContentBuilder/templates/models/CTI_66.props';

export const cnStory = cn('Story');

type Props = Group & {
  viewed: boolean;
};
export const Story: React.FC<Props> = props => {
  const { title, icon, viewed } = props || {};

  return (
    <div className={cnStory({ viewed: viewed })}>
      <div
        className={cnStory('Image')}
        style={{ backgroundImage: `url(${icon?.desktopWebp})` }}
      />
      {title && (
        <Typography.Text className={cnStory('Label')} size="m">
          {title}
        </Typography.Text>
      )}
    </div>
  );
};
